export const getSecret = (organization, serviceAccountId) =>
  `/api/v1/organizations/${organization.id}/service_accounts/${serviceAccountId}/secret`;
export const serviceAccounts = (organization) => `/api/v1/organizations/${organization.id}/service_accounts`;
